/* global $ */

import Promise from 'bluebird';

const $container = $('.js-settings-container');
const $competitorInputContainers = $container.find('.js-competitor-input-container');
const $competitorInputs = $container.find('.js-competitor-input');
const $competitorBtnSave = $container.find('.js-competitor-btn-save');
const $emailSubscriptionsForm = $container.find('.js-email-subscriptions-form');
const $emailSubscriptionsBtnSave = $container.find('.js-email-subscriptions-btn-save');

function setCompetitors (projectUrl, competitors) {
  const lang = window.wooGlobal.language;
  const apiURL = `/${lang}/project/setcompetitors`;
  return Promise.resolve($.post(apiURL, {
    projectUrl: projectUrl,
    competitors: competitors
  }));
}

function setEmailSubscriptions (projectUrl, subscriptions) {
  const lang = window.wooGlobal.language;
  const apiURL = `/${lang}/project/setemailsubscriptions`;
  return Promise.resolve($.post(apiURL, {
    projectUrl: projectUrl,
    subscriptions: subscriptions
  }))
  .then((response) => {
    if (response.result === false) {
      throw new Error(response.reason);
    }
  });
}

$competitorInputContainers.find('.js-remove-competitor').on('click', function (e) {
  e.preventDefault();
  let $formGroup = $(this).parents('.form-group');
  let $input = $formGroup.find('input');
  $input.val('');
  $input.focus();
  $formGroup.removeClass('has-error');
});

$competitorBtnSave.on('click', function (event) {
  const $this = $(this);
  const lang = window.wooGlobal.language;
  $this.removeClass('success');
  $this.removeClass('error');
  $this.addClass('busy');

  const projectUrl = $this.attr('data-project-url');
  const competitors = $competitorInputs.map(function (index, input) {
    return input.value;
  }).toArray();

  setCompetitors(projectUrl, competitors)
  .then((response) => {
    if (response.result === false) {
      let resp = response.validation;
      for (let i = 0; i < resp.length; i++) {
        if (!resp[i].validCompetitor) {
          $('#competitor-' + (1 + i)).addClass('has-error');
        }
      }
      $this.removeClass('busy');
    } else {
      $this.addClass('success');
      window.location.href = `/${lang}/settings/${projectUrl}`;
    }
  })
  .finally(() => {
    $this.removeClass('busy');
  });
});

$emailSubscriptionsBtnSave.on('click', function (event) {
  event.preventDefault();
  const $this = $(this);

  $this.removeClass('success');
  $this.removeClass('error');
  $this.addClass('busy');

  const projectUrl = $this.attr('data-project-url');
  const subscriptions = $emailSubscriptionsForm.serializeArray()
  .reduce((acc, entry) => {
    return Object.assign(acc, {
      [entry.name]: entry.value
    });
  }, {});

  setEmailSubscriptions(projectUrl, subscriptions)
  .then(() => { $this.addClass('success'); })
  .catch(() => { $this.addClass('error'); })
  .finally(() => {
    $this.removeClass('busy');
  });
});
